import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FloorInfoSet1Ex, InfoAboutFlat, ISpot, RoomTypeEnum} from "../../../shared/models/models";
import {MatTabGroup, MatTabsModule} from "@angular/material/tabs";
import {CommonModule} from "@angular/common";
import {CommercialRoomsComponent} from "../commercial-rooms/commercial-rooms.component";
import {NumberWithSpacesPipe} from "../../../shared/pipes/number-with-spaces.pipe";

@Component({
  selector: 'app-spot-form-tabs',
  templateUrl: './spot-form-tabs.component.html',
  styleUrl: './spot-form-tabs.component.scss',
  standalone: true,
  imports: [MatTabsModule, CommonModule, CommercialRoomsComponent, NumberWithSpacesPipe]
})
export class SpotFormTabsComponent implements OnChanges {

  @ViewChild('tabGroup') tabGroup!: MatTabGroup;

  @Input() currentTabIndex: RoomTypeEnum = RoomTypeEnum.Flats;

  @Input() spotObject: ISpot;
  @Input() obj: FloorInfoSet1Ex[] = [];
  @Input() reloadTrigger: number;

  @Output() openFlat = new EventEmitter<InfoAboutFlat>();
  @Output() openTypicalFloor = new EventEmitter<void>();
  @Output() deleteFlat = new EventEmitter<{
    buildingID: number,
    floorID: number,
    roomCountID: number,
    flatInfo: any,
    index: number,
    flatID: number
  }>();

  @Output() currentTabIndexChange = new EventEmitter<number>();

  chooseFlat(flat: InfoAboutFlat) {
    this.openFlat.emit(flat);
  }

  onDeleteFlat(buildingID: number, floorID: number, roomCountID: number, flatInfo: any, index: number, flatID: number) {
    this.deleteFlat.emit({buildingID, floorID, roomCountID, flatInfo, index, flatID});
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentTabIndex'] && !changes['currentTabIndex'].firstChange) {
      setTimeout(() => {
        this.goToTab(this.currentTabIndex);
      });
    }
  }

  goToTab(index: number): void {
    if (this.tabGroup) {
      this.tabGroup.selectedIndex = index;
    } else {
      console.warn('tabGroup не инициализирован');
    }
  }

  loadedTabs = new Set<number>([RoomTypeEnum.Flats]);

  onTabChange(index: number): void {
    this.loadedTabs.add(index);
    this.currentTabIndex = index;
    this.currentTabIndexChange.emit(index);
  }

  protected readonly RoomTypeEnum = RoomTypeEnum;
}
